import script from "./SlideDeckComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideDeckComponent.vue?vue&type=script&setup=true&lang=js"

import "./SlideDeckComponent.vue?vue&type=style&index=0&id=facd3ba0&lang=css"

const __exports__ = script;

export default __exports__